export default __webpack_public_path__ + "static/media/radioActive.d9b96c9e.svg";